import comp from "./JournalFeed";
export default comp;
